/**
 * Error signalling that the Cognito session can no longer be retrieved or
 * refreshed — i.e. the refresh token has expired or become invalid.
 *
 * It is raised specifically when `getSession()` rejects, so callers can
 * distinguish a genuinely dead session (which must trigger a logout) from
 * unrelated failures such as an HTTP error or an RxJS `TimeoutError`, which
 * should be handled differently (e.g. shown on the error page).
 */
export class SessionExpiredError extends Error {
  /**
   * @param originalError - The underlying error thrown by the Cognito SDK, if
   * any, kept for logging/debugging purposes.
   */
  constructor(readonly originalError?: unknown) {
    super("Cognito session expired or could not be refreshed");
    this.name = "SessionExpiredError";
    // Restore the prototype chain so `instanceof` works regardless of the
    // compilation target.
    Object.setPrototypeOf(this, SessionExpiredError.prototype);
  }
}
